// extracted by mini-css-extract-plugin
export default {"root":"root--BdOCt","link":"link--u6LOl","btn":"btn--tWDEa"};